import {Component, EventEmitter, forwardRef, Input, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseControlDirective} from '../../directives/base-control.directive';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true},
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => CheckboxComponent), multi: true}
  ]
})
export class CheckboxComponent extends BaseControlDirective implements ControlValueAccessor {
  @Input() id: any;
  @Input() label: string;
  @Input() checked: boolean;
  @Input() checkedAlternativeStyle: boolean;

  @Output() keydownTab: EventEmitter<Event> = new EventEmitter();
  @Output() checkBoxToggled: EventEmitter<boolean> = new EventEmitter(false); // Enter Keydown  Event

  @ViewChild('checkBox') checkBox;
  
  onChange = (_) => {};
  blurred = (_) => {};

  onChanged($event): void {
    this.checked = $event && $event.target && $event.target.checked;
    this.onChange(this.checked);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.blurred = fn;
  }

  onEnterKeyPress() {
    this.checked = !this.checked;
    this.checkBoxToggled.next(this.checked);
  }

  onFocus() {
   this.checkBox.nativeElement.classList.add('focused');
  }

  onFocusOut() {
    this.checkBox.nativeElement.classList.remove('focused');
  }
}
